import { Box, Typography } from "@mui/material";
import { ArrowRight } from "@mui/icons-material";

const ArrowStatus = ({ value, color }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "30px",
        padding: "0 !important",
        margin: "0 !important",
      }}
    >
      <Typography
        variant="body1" 
        color={value.toString() === "0" ? "black" : color}
        fontWeight="bold"
      >
        {value.toString() === "0" ? "-" : value}
      </Typography>
      {(value.toString() !== "0" && !value.toString().includes("&")) && (
        <ArrowRight
          sx={{
            height: "0.8em !important",
            width: "0.4em !important",
            transform: "rotate(-90deg)",
            fontSize: "40px",
            color: color,
            padding: "0 !important",
            margin: "0 -12px 0 0 !important",
          }}
        />
      )}
    </Box>
  );
};

export default ArrowStatus;
